class FormContact extends HTMLElement {
    constructor() {
    super();
    this.init();
    this.errorsFields = {
        'en' : {
            'required': 'Please complete this required field.',
            'email': 'Please enter a valid email address (Ex: johndoe@domain.com).',
            'phone': 'Please enter a valid phone number. For example 1234567890 or (123) 456-7890 or 123-456-7890.'
        },
        'fr': {
            'required': 'Veuillez remplir ce champ obligatoire.',
            'email': 'L\'adresse e-mail n\'est pas valide',
            'phone': 'Veuillez saisir un numéro de téléphone valide. Par exemple 1234567890 ou (123) 456-7890 ou 123-456-7890.'
        }
    }
    }

    init() {
        this.form = this.querySelector('form');
        this.submit = this.form.querySelector('.button_submit');
        this.elemetnsRequired = this.querySelectorAll('input.required');
        this.submit.addEventListener('click', this.checkErrors.bind(this));
    }

    checkErrors(evt) {
        evt.preventDefault();
        let _errors = false;
        if(this.elemetnsRequired.length){
            this.elemetnsRequired.forEach((input) => {
                const _val = input.value;
                const _name = input.getAttribute('name');
                const _field = input.getAttribute('data-name');
                if(!this.checkError(input, _name, _val, _field)) {
                    _errors = true;
                }
            });
        }

        if(!_errors){
            this.form.submit();
        } else {
            const elementError = document.querySelector('._error');
            if(elementError){
                let y = elementError.getBoundingClientRect().top + window.scrollY - StoreHeader.getHeaderEnd() - 60;
                window.scroll({
                    top: y,
                    behavior: 'smooth'
                  });
              setTimeout(() => {
                const y = elementError.getBoundingClientRect().top + window.scrollY - StoreHeader.getHeaderEnd() - 60;
                window.scroll({
                    top: y,
                    behavior: 'smooth'
                  });
              }, 350);
            }
        }
    }

    checkError(_elem, _name, _val, _field) {
        let _v = true;
        let _errorContent = document.createTextNode(this.errorsFields[Shopify.locale]['required']);
        if(_elem.parentNode.querySelector('._error')){
            _elem.parentNode.querySelector('._error').remove()
          }
          if(!_val) {
            const _error = document.createElement("p");
            _error.classList.add('_error');
            _error.appendChild(_errorContent);
            _elem.parentNode.appendChild(_error);
            _v = false;
          } else {
            if(_field == 'phone') {
                _v = _val.match(/\d/g).length===10;
            }
            if(_field == 'email') {
              _v = /^([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*@([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*\.(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]){2,})$/i.test(_val);
            }
            if(!_v){
                const _error = document.createElement("p");
                _error.classList.add('_error');
                _error.appendChild(document.createTextNode(this.errorsFields[Shopify.locale][_field]));
                _elem.parentNode.appendChild(_error);
            }
          }
          return _v;
    }
}
  
customElements.define('form-contact', FormContact);
